import actionType from "./GISIPWPM01ActionType";

// レスポンスState定義
const infoState = {
    isFetching: false,
    isError: false,
    isDelete: false,
    data: [],
    overflowflg: "",
    err_type: "",
    err_detail: []
};

/**
 * 作業計画案件一覧データ取得
 * @param {*} state
 * @param {*} action
 */
export const getWorkingPlanCaseList = (state = infoState, action) => {
    switch (action.type) {
        case actionType.GET_WORK_PLAN_CASE_LIST_REQUEST:
            return Object.assign({}, state, {
                isFetching: true,
                data: [],
                overflowflg: "",
                isDelete: false,
                isError: false,
                err_type: "",
                err_detail: []
            });
        case actionType.GET_WORK_PLAN_CASE_LIST_SUCCESS:
            return Object.assign({}, state, {
                isFetching: false,
                data: action.data.data.list,
                overflowflg: action.data.data.overflowflg,
                isError: false,
                err_type: action.data.err_type,
                err_detail: action.data.err_detail
            });
        case actionType.GET_WORK_PLAN_CASE_LIST_FAILURE:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                overflowflg: "",
                isError: true,
                err_type: action.err,
                err_detail: []
            });
        case actionType.GET_WORK_PLAN_CASE_LIST_RESET:
            return Object.assign({}, state, {
                isFetching: false,
                data: [],
                overflowflg: "",
                isError: false,
                err_type: "",
                err_detail: []
            });
        default:
            return state;
    }
};
